/**
 * /star2 — versão alternativa da LP da Star Cursos (layout livre, foco em
 * conversão). Mesma copy validada de /star; ordem e ênfase diferentes.
 */
import { createFileRoute } from "@tanstack/react-router";

import {
  StarCarreira,
  StarComoFunciona,
  StarDepoimentos,
  StarDuvidas,
  StarFaq,
  StarGarantias,
  StarHero,
  StarNomes,
  StarPlanos,
  StarSobre,
  StarStats,
  StarStickyCta,
  StarVideo,
} from "@/components/star/blocks";

const TITLE = "Star Cursos · +100 cursos de fisioterapia musculoesquelética";
const DESCRIPTION =
  "Assine a Star Cursos e tenha acesso imediato a +100 cursos com certificação em fisioterapia musculoesquelética, com +50 professores e +350 horas de conteúdo. Planos anual e de 3 anos.";

export const Route = createFileRoute("/star2")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      // versão B do teste A/B: fora do índice pra não duplicar /star
      { name: "robots", content: "noindex,nofollow" },

    ],
  }),
  component: Star2Page,
});

function Star2Page() {
  return (
    <main className="min-h-screen bg-white antialiased pb-20 lg:pb-0">
      {/* prova social já na dobra + oferta logo em seguida */}
      <StarHero compact />
      <StarStats inline />
      <StarPlanos comparativo />
      <StarGarantias />
      <StarSobre bento />
      <StarComoFunciona />
      <StarVideo />
      <StarDepoimentos />
      <StarCarreira />
      <StarNomes />
      {/* oferta repetida no fim */}
      <StarPlanos comparativo anchor={false} />
      <StarFaq />
      <StarDuvidas />
      <StarStickyCta />
    </main>
  );
}
